import LocationAndPoints from '../../../../components/location-and-points/location-and-points.desktop';
import locationAndPoints from './location-and-points';

export default locationAndPoints(LocationAndPoints);
